import { UploaderScroller } from "../../../../Reusable/BrandedCoverUploader/UploaderScroller.js";
import React, { useMemo, useState } from "react";
import "./ProfilePictureUpload.scss";
import Icon from "../../../../Elements/Icon/Icon.tsx";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import AvatarEditor from "react-avatar-editor";
import { useMail } from "../../../../../contexts/mailContext/mailContext.js";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";
import { useToasts } from "react-toast-notifications";
import { useUser } from "../../../../../contexts/userContext/userContext.js";

const _URL = window.URL || window.webkitURL;

const ProfilePictureSelector = React.forwardRef(
  (
    {
      image,
      size,
      handleClick,
      imageSizes,
      setImageSizes,
      scale,
      setScale,
      cancelUpload,
      error,
      isContactList
    },
    ref
  ) => {
    const { getTextByKey } = useContent();

    const { closeModal } = useModal();
    const { addToast } = useToasts();

    const { isSpecificBackground, resetSpecificMailBrandedCover } = useMail();
    const { getUserProfileImage } = useUser();

    //scroller scaling logic
    const handleScale = (e) => {
      const scale = parseFloat(e.target.value);
      setScale(scale);
    };

    const handleResetCover = async () => {
      const response = await resetSpecificMailBrandedCover();
      if (response.status === "success") {
        closeModal();
        addToast(getTextByKey("upload-profile-picture-success"), {
          appearance: "success",
        });
      }
    };

    const displayImage = isContactList ? image : image || getUserProfileImage()

    useMemo(() => {
      if (image) {
        //check if image is from url or from file
        const imageIsUrl = image.startsWith("http");
        const img = new Image();
        img.onload = function () {
          setImageSizes(() => ({
            valid: imageIsUrl ? true : this.width >= 250 && this.height >= 250,
            width: this.width > 250 ? 250 : this.width,
            height:
              this.width > 250 ? 250 * (this.height / this.width) : this.height,
          }));
        };
        if (typeof image !== "string") {
          const url = _URL.createObjectURL(image);
          img.src = url;
        } else {
          img.src = image;
        }
      }
    }, [image]);

    return (
      <div
        className={`profile-picture-selector ${
          image ? "selector-with-picture" : "empty-image"
        }`}
      >
        <div className={`profile-picture ${image ? "with-picture" : ""}`}>
          {image && (
            <div className="actions">
              <div className="upload-image" onClick={handleClick}>
                <Icon name="camera" />
              </div>
            </div>
          )}
          <div
            className={`profile-picture-selector-center ${
              image ? "profile-picture-image-selected" : ""
            }`}
            style={
              !image
                ? {
                    height: `${260}px`,
                  }
                : {}
            }
          >
            {(image && !imageSizes.valid) || error ? (
              <div className="validation-size-container">
                {getTextByKey(
                  error ? error : "business-logo-validation-size-text"
                )}
              </div>
            ) : null}
            {displayImage ? (
              <AvatarEditor
                ref={ref}
                image={displayImage}
                width={Math.round(250)}
                height={Math.round(250)}
                crossOrigin=""
                border={0}
                //color={[255, 255, 255, 0.6]} // RGBA
                scale={parseFloat(scale)}
                rotate={0}
                borderRadius={Math.round(imageSizes.height)}
              />
            ) : (
              <div className="click-to-action-circle" onClick={handleClick}>
                <Icon name="cloud-upload" white></Icon>
                <span>{getTextByKey("profile-upload-image-button")}</span>
              </div>
            )}
          </div>
        </div>
        {image && imageSizes.width > 50 ? (
          <UploaderScroller
            image={image}
            handleScale={handleScale}
            maxValue={imageSizes.width / 100}
          />
        ) : isSpecificBackground() ? (
          <div
            className="reset-background-image"
            onClick={() => handleResetCover()}
          >
            {getTextByKey("reset-profile-image-text")}
          </div>
        ) : null}
      </div>
    );
  }
);

export default ProfilePictureSelector;
